import { API_URL } from '../constants';

type ApiMethod = (props: { endpoint: string | null; options?: RequestInit }) => Promise<Response>;

/**
 * @example
 * // Example usage of the custom fetch object
 * // You would do this
 * import api from '@/Utils/getServer';
 * api('/products/1', {method: 'GET'});
 *
 * // Instead of this
 * fetch('localhost:5000/api/v1/products/1', {method: 'GET'});
 *
 * @description
 * This is a custom Fetch object, it loads server URL as a base URL,
 * so you won't have to keep adding the full URL everytime. Also, to control
 * the server port whenever it changes, and adapt to server mode (dev, prod).
 *
 * @param {String} endpoint - The endpoint you want to get, post, delete, ...
 * @param {RequestInit} options - Same options you would pass with Fetch API
 *
 * @returns {Promise<Response>} A promise that resolves to the Response object from the fetch request.
 */
export const api: ApiMethod = ({ endpoint, options }) => {
  return fetch(`${API_URL}${endpoint}`, options);
};
